import { render, staticRenderFns } from "./ExternalLinkSetting.vue?vue&type=template&id=746e15ec&scoped=true"
import script from "./ExternalLinkSetting.vue?vue&type=script&lang=js"
export * from "./ExternalLinkSetting.vue?vue&type=script&lang=js"
import style0 from "./ExternalLinkSetting.vue?vue&type=style&index=0&id=746e15ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746e15ec",
  null
  
)

export default component.exports